import Text from '@zenbusiness/common-components/Text';
import Title from '@zenbusiness/common-components/Title';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';

const Section = ({
  title, description, children, hasExpertsPill
}) => (
  <Box data-testid="section">
    {hasExpertsPill && (
      <Box mb={{ xs: 3, md: 3 }}>
        <Chip
          sx={{
            fontSize: 13,
            fontWeight: 600,
            backgroundColor: 'peace10.main',
            textTransform: 'uppercase',
            width: 'fit-content'
          }}
          label="Meet with experts"
        />
      </Box>
    )}
    <Box mb={{ xs: 3, md: 5 }}>
      <Title level={2} variant="smallBold" gutterBottom>{title}</Title>
      {description && (
        <Text size="md" color="focus50">{description}</Text>
      )}
    </Box>
    {children}
  </Box>
);
Section.propTypes = {
  /** Title of the section. */
  title: PropTypes.string.isRequired,
  /** Description of the section. */
  description: PropTypes.string,
  /** The content of the component. */
  children: PropTypes.node.isRequired,
  /** Pill Position */
  hasExpertsPill: PropTypes.bool
};

export default Section;
